"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const apiHelpers_1 = require("./apiHelpers");
class Loader {
    constructor({ apiKey, context, endpoints = undefined, timeout, clientVersion = "", }) {
        this.apiKey = apiKey;
        this.context = context;
        this.endpoints = endpoints || [
            "https://api-prefab-cloud.global.ssl.fastly.net/api/v1",
            "https://api.prefab.cloud/api/v1",
        ];
        this.timeout = timeout || apiHelpers_1.DEFAULT_TIMEOUT;
        this.clientVersion = clientVersion;
    }
    url(root) {
        return `${root}/configs/eval-with-context/${this.context.encode()}`;
    }
    loadFromEndpoint(index, options, resolve, reject) {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        const endpoint = this.endpoints[index];
        const url = this.url(endpoint);
        fetch(url, Object.assign({ signal }, options))
            .then((response) => {
            this.clearAbortTimeout();
            if (response.ok) {
                return response.json();
            }
            throw new Error(`${response.status} ${response.statusText}`);
        })
            .then((data) => {
            resolve(data.values);
        })
            .catch((error) => {
            this.clearAbortTimeout();
            if (index < this.endpoints.length - 1) {
                this.loadFromEndpoint(index + 1, options, resolve, reject);
            }
            else {
                reject(error);
            }
        });
        this.abortTimeoutId = setTimeout(() => {
            var _a;
            (_a = this.abortController) === null || _a === void 0 ? void 0 : _a.abort();
        }, this.timeout);
    }
    load() {
        var _a;
        (_a = this.abortController) === null || _a === void 0 ? void 0 : _a.abort();
        const options = { headers: (0, apiHelpers_1.headers)(this.apiKey, this.clientVersion) };
        const promise = new Promise((resolve, reject) => {
            this.loadFromEndpoint(0, options, resolve, reject);
        });
        return promise;
    }
    clearAbortTimeout() {
        clearTimeout(this.abortTimeoutId);
    }
}
exports.default = Loader;
